import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as adminActions from './../redux/actions';
import * as eventActions from '../../event/redux/actions';
import * as categoryActions from '../../category/redux/actions';
import AdminLayout from '../AdminLayout';
import { Row, Col, message, Select, Modal, Button, Icon } from 'antd';
import withDragDropContext from '../../../helper/DND/withDragDropContext';
import CardDND from './item/CardDND';
import CardDNDList from './item/CardDND.bis';
import ContainerDND from './item/ContainerDND';
import { API } from '../../../helper/api';
import { Inputs } from '../../../helper/form/input';

const Option = Select.Option;

export class EventsTop extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    categories: [],
    cards: [],
    tops: [],
    modal_visible: false,
    new_name: '',
    new_name_is_valid: false
  }

  componentWillMount() {
    this.props.actions.getEvents("ASC", { 'images': 'True', 'categories': 'True' }).then(
      API.get('/topevent/list').then(res => this.setState({ tops: res.data, cards: res.data.map(o => ({ id: o.index, eventId: o.event.id })) }))
    );
    this.props.actions.getCategories();
  }

  handleDrop = (id) => {
    if (this.state.cards.length >= 4) {
      message.error('Maximum 4 évenements')
    }
    else if (!this.state.cards.map(c => c.eventId).includes(id)) {
      this.setState({ id, modal_visible: true})
    }
  }

  addToTop = () => {
    if(this.state.id && this.state.new_name )
    //save it
    API.post('/TopEvent/add/' + this.state.id + '/' + this.state.new_name)
    //.then(() => console.log([ this.state.tops, { name : this.state.new_name, event : this.props.event.list.filter(e => e.id === this.state.id)[0]}]))
    .then(() =>
      //render
      this.setState({
        tops: [ ...this.state.tops, { name : this.state.new_name, event : this.props.event.list.filter(e => e.id === this.state.id)[0]}],
        cards: [ ...this.state.cards, { id: (this.state.cards.length + 1), eventId: this.state.id }]
      })
    )
    .then(() => this.withReset())
    .catch(() => this.withReset())
  }

  onRemove = (id) => {
    API.delete('topevent/'+id).then(() =>
      this.setState(({ cards, tops }) => ({
         tops: tops.filter(t => t.event.id !== id), 
         cards: cards.filter(c => c.eventId !== id).map((o,i) => ({ id: (i + 1), eventId: o.eventId })) 
      }))
    )
  }

  withReset = (state = {}) => this.setState({
    ...state,
    id: null,
    new_name: '',
    new_name_is_valid: false,
    modal_visible: false
  });

  removeModal = () => this.withReset();

  moveCard = (id, atIndex) => {
    const { card, index } = this.findCard(id);
    let cards = this.state.cards.slice();
    cards[index] = cards[atIndex];
    cards[atIndex] = card;

    this.setState({ cards })
  }

  findCard = (id) => {
    const { cards } = this.state
    const card = cards.filter(c => c.id === id)[0]

    return {
      card,
      index: cards.indexOf(card),
    }
  }

  render() {
    return (
      <AdminLayout
        title="ÉVÉNEMENTS À LA UNE"
      >
        <Row className="admin-events-top">
          <div style={{ overflow: 'hidden', clear: 'both' }}>
            <ContainerDND>
              {this.state.cards
                .map((card, i) => {
                  const event = this.state.tops.filter(e => e.event.id === card.eventId)[0];

                  if (!event) return

                  return (<CardDNDList
                    key={card.id}
                    id={card.id}
                    moveCard={this.moveCard}
                    findCard={this.findCard}
                    onRemove={this.onRemove}
                    event={event.event}
                  />)
                })}
            </ContainerDND>
          </div>
          <Row type="flex" justify="start">
            <Col xs={{ span: 22, offset: 1 }}>
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 4 }} >
                <Select
                  placeholder="Sélectionnez la catégorie"
                  showSearch
                  mode="multiple"
                  onChange={(categories) => this.setState({ categories })}
                  style={{ display: 'block' }}
                >
                  {this.props.category.list.map((c, i) => <Option key={i} value={c.name} >{c.name}</Option>)}
                </Select>
              </Col>
            </Col>
          </Row>
          <Row style={{maxHeight: '500px', overflowY: 'auto', marginTop: '20px'}}>
            <Col xs={{ span: 22, offset: 1 }}>
              {this.props.event.list
                .filter(e => this.state.categories.length === 0 || e.eventCategory.some(r => this.state.categories.includes(r.category.name)))
                .filter(e => !this.state.cards.map(c => c.eventId).includes(e.id))
                .map((e, i) => <CardDND onChange={this.handleDrop} key={i} event={e} />)
              }
            </Col>
          </Row>
          <Modal
            title='Ajouter une phrase'
            style={{ top: 50 }}
            width={700}
            visible={this.state.modal_visible}
            onCancel={this.removeModal}
            onOk={this.removeModal}
            footer={[
              <Button key="back" onClick={this.removeModal}>
                <Icon type="delete" />
                ANNULER
              </Button>,
              <Button
                key="submit"
                type="primary"
                disabled={!this.state.new_name_is_valid}
                onClick={this.addToTop}>
                <Icon type="plus" />
                AJOUTER
              </Button>,
          ]}
          >
            <Inputs.Item
                value={this.state.new_name}
                placeholder="Nom"
                onCheck={(new_name_is_valid) => this.setState({ new_name_is_valid })}
                onChange={(new_name) => this.setState({ new_name })}
                isValid={(name) => name.length >= 2}
                status={{ success: '', error: 'La phrase doit faire plus de deux caractères' }}
                checkOnChange
                notEmpty
              />
          </Modal>
        </Row>
      </AdminLayout>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    event: state.event,
    category: state.category
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...adminActions, ...eventActions, ...categoryActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withDragDropContext(EventsTop));


// WEBPACK FOOTER //
// ./src/features/admin/events/Top.js